import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Select from "react-select";
import apiServiceHandler from "../../service/apiService";
import "toastr/build/toastr.min.css";
import toastr from "toastr";

const EditFeaturedCourseModal = ({ isOpen, onClose, setRefreshFeaturedCourse, editData }) => {
  const [title, setTitle] = useState("");
  const [featuredCourseLink, setFeaturedCourseLink] = useState("");
  const [thumbnail, setThumbnail] = useState(null);

  useEffect(() => {
    if (isOpen && editData) {
      setTitle(editData.title);
      setFeaturedCourseLink(editData.course_url);
    }
  }, [isOpen, editData]);

  const handleThumbnailChange = (e) => {
    const file = e.target.files[0];
    setThumbnail(file);
  };

  const sendUpdateFeaturedCourse = async () => {
    if (!title || !featuredCourseLink) {
      toastr.error("Please fill in all fields");
      throw new Error("Please fill in all fields");
    }

    const formData = new FormData();
    formData.append("title", title);
    formData.append("course_url", featuredCourseLink);
    if (thumbnail) {
      formData.append("thumbnail", thumbnail);
    }

    try {
      const response = await apiServiceHandler("PATCH", `api/featured/courses/${editData._id}`, formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });

      if (response.auth) {
        toastr.success(response.message);
        setRefreshFeaturedCourse(true);
        onClose();
      } else {
        toastr.error(response.message || "Failed to update featured course. Please try again.");
      }
    } catch (error) {
      toastr.error(error.response?.data?.message || "An error occurred");
      console.error(error);
    }
  };

  return (
    <Modal show={isOpen} onHide={onClose} centered>
      <Modal.Header closeButton style={{ borderBottom: "none" }}>
        <Modal.Title>Edit Featured Course</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="invite-form__fields">
          <div className="invite-form__field">
            <div className="text-input__label">Title</div>
            <div className="form-input__wrapper">
              <input
                type="text"
                className="form-input__input"
                value={title}
                onChange={(e) => setTitle(e.target.value)} />
            </div>
          </div>
          <div className="invite-form__field">
            <div className="text-input__label">Recording URL</div>
            <div className="form-input__wrapper">
              <input
                type="text"
                className="form-input__input"
                value={featuredCourseLink}
                onChange={(e) => setFeaturedCourseLink(e.target.value)} />
            </div>
          </div>
          <div className="invite-form__field">
            <div className="text-input__label">Thumbnail</div>
            <div className="form-input__wrapper">
              <input
                type="file"
                className="form-input__input"
                accept="image/*"
                onChange={handleThumbnailChange} />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer style={{ borderTop: "none", paddingTop: '1rem' }}>
        <button className="send-invite__btn" onClick={sendUpdateFeaturedCourse}>
          <span className="send-invite-button__label">Update</span>
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditFeaturedCourseModal;
